import { apiGet } from 'shared/services/api/resource';
import { NearbyArena, NEARBY_ARENAS, NEXT_GAME } from 'modules/jogador/player-home/content';

export interface NextGame {
  title: string;
  location: string;
  spotsLabel: string;
  startsInLabel: string;
}

export interface PlayerHomeData {
  nextGame: NextGame | null;
  nearbyArenas: NearbyArena[];
}

// Em produção o próximo jogo e as arenas próximas dependem do esporte selecionado
// e da localização do jogador — por isso já recebe `sport`.
export function fetchPlayerHome(sport: string): Promise<PlayerHomeData> {
  return apiGet({ nextGame: NEXT_GAME, nearbyArenas: NEARBY_ARENAS }, `/me/home?sport=${encodeURIComponent(sport)}`);
}
